export default values => ({
  name: values ? values.name : '',
  department: values ? values.department : '',
  position: values ? values.position : '',
  office: values ? values.office : '',
  phone: values ? values.phone : '',
  email: values ? values.email : '',
});
